import { render, staticRenderFns } from "./UpdatePicForm.vue?vue&type=template&id=23274a82&"
import script from "./UpdatePicForm.vue?vue&type=script&lang=js&"
export * from "./UpdatePicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports